export default [
  {
    path: "/theatre/seatManage",
    component: () => import("@/pages/brandsManage/theatre/seatManage.vue"),
    name: "seatManage",
    title: "座位图管理",
    meta: {
      title: "座位图管理"
    }
  },
  {
    path: "/theatre/categoryManage",
    component: () => import("@/pages/brandsManage/theatre/categoryManage.vue"),
    name: "theatreCategoryManage",
    title: "分类管理",
    meta: {
      title: "分类管理"
    }
  },
  {
    path: "/theatre/activityManage",
    component: () => import("@/pages/brandsManage/theatre/activityManage.vue"),
    name: "theatreActivityManage",
    title: "剧场票务列表",
    meta: {
      title: "剧场票务列表"
    }
  },
  {
    path: "/theatre/setTicket",
    component: () => import("@/pages/brandsManage/theatre/setTicket.vue"),
    name: "theatreSetTicket",
    title: "剧场票务设置",
    meta: {
      title: "剧场票务设置"
    }
  },
  {
    path: "/theatre/activityOrder",
    component: () => import("@/pages/brandsManage/theatre/activityOrder.vue"),
    name: "theatreActivityOrder",
    title: "票务订单管理",
    meta: {
      title: "票务订单管理"
    }
  }
];
